import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import Accordion from "../../../components/accordion/Accordion";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip} from "@mui/material";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import axios from "axios";
import {MdDeleteForever, MdEdit} from "react-icons/md";
import {BiSolidCategoryAlt} from "react-icons/bi";
import CustomLoader from "../../../components/ConfirmationModal/CustomLoader";

function AddNewPermitDoc() {
    const [accordionData, setAccordionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        titleEng: '',
        permitTypeID: 0,
        icon: '',
        url: '',
        departmentId: 1
    });

    const [deletePermitId, setDeletePermitId] = useState(null);
    const [isAdding, setIsAdding] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editFormData, setEditFormData] = useState({
        permitTypeId: 0,
        title: '',
        icon: '',
        url: '',
        departmentId: 0,
        titleEng: '',
    });
    const [editConfirmationModalOpen, setEditConfirmationModalOpen] = useState(false);
    const handlePreEditSubmit = () => {
        setEditConfirmationModalOpen(true);
    };
    const handleOpenEditDialog = (item) => {
        setEditFormData({
            ...editFormData,
            permitTypeId: item.id,
            title: item.title,
            titleEng: item.titleEng,
            icon: item.icon,
            url: item.url,
            departmentId: item.departmentId,
        });
        setEditDialogOpen(true);
    };
    const handleActualEditSubmit = async () => {
        setIsLoading(true);
        try {
         await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdatePermitType`, editFormData);

        } catch (error) {
        } finally {
            void fetchAccordionData();
            setIsLoading(false);
            setEditDialogOpen(false);
            setEditConfirmationModalOpen(false);
        }
    };
    const handleEditChange = (event) => {
        setEditFormData({...editFormData, [event.target.name]: event.target.value});
    };
    const handleEditChangeEng = (event) => {
        setEditFormData({...editFormData, [event.target.name]: event.target.value});
    };
    const fetchAccordionData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
            setAccordionData(response.data.data || []);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAccordionData();
    }, []);

    const handleOpenDialog = (permitTypeID) => {
        setFormData({...formData, permitTypeID});
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleOpenDeleteDialog = (id) => {
        setDeletePermitId(id);
        setDeleteDialogOpen(true);
    };

    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
    };

    const handleChange = (event) => {
        setFormData({...formData, [event.target.name]: event.target.value});
    };
    const handleChangeEng = (event) => {
        setFormData({...formData, [event.target.name]: event.target.value});
    };

    const handlePreSubmit = () => {
        setConfirmationModalOpen(true);
    };

    const handleSubmit = async () => {
        setIsAdding(true); // Start loading for add operation
        setConfirmationModalOpen(false);
        try {
             await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddPermitType`, formData);
        } catch (error) {
        } finally {
            setIsAdding(false);
            handleCloseDialog();
            await fetchAccordionData();
        }
    };

    const handleDeleteSubmit = async () => {
        if (deletePermitId !== null) {
            setIsDeleting(true);
            try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/ DeletePermitType`, {id: deletePermitId});
            } catch (error) {
            } finally {
                setIsDeleting(false);
                setDeleteDialogOpen(false);
                void fetchAccordionData();
            }
        }
    };

    const renderAccordion = (accordionItem, isLastChild = false, isTopLevel = true) => {
        const isLastLevel = !accordionItem.childrenPermitTypes || accordionItem.childrenPermitTypes.length === 0;
        const hasChildren = accordionItem.childrenPermitTypes && accordionItem.childrenPermitTypes.length > 0;
        const childrenHaveNoChildren = hasChildren && accordionItem.childrenPermitTypes.every(child => !(child.childrenPermitTypes && child.childrenPermitTypes.length > 0));

        return isLastLevel ? (
            <div key={accordionItem.id} style={{marginBottom: 5}}>
                <div style={{
                    color: '#3872F2',
                    fontFamily: "'FiraGO-SemiBold'",
                    textDecoration: 'none',
                    display: "flex",
                    marginTop: 20
                }}>
                    <div style={{width: 700,}}>
                        <Link to={`/dashboard/addnewdoc?id=${accordionItem.id}`}
                              style={{color: accordionItem.url ? '#3872F2' : 'red', textDecoration: 'none'}}>
                            {accordionItem.title}
                        </Link>
                    </div>
                    <div>
                        <Tooltip title={"სახელის შეცვლა"}>
                               <span>
                            <MdEdit
                                style={{fontSize: 40, cursor: 'pointer', color: "black"}}
                                onClick={() => handleOpenEditDialog(accordionItem)}
                            />
                                               </span>
                        </Tooltip>
                        <Tooltip title={"კატეგორიად გადაკეთება"}>
                                  <span>
                            <BiSolidCategoryAlt
                                style={{marginLeft: '10px', fontSize: 40, cursor: "pointer", color: "#3872F2"}}
                                onClick={() => handleOpenDialog(accordionItem.id)}>
                            </BiSolidCategoryAlt>
                                                             </span>
                        </Tooltip>
                        <Tooltip title={"წაშლა"}>
                            <span>
                                        <MdDeleteForever
                                            style={{marginLeft: '10px', fontSize: 40, cursor: "pointer", color: "red"}}
                                            onClick={() => handleOpenDeleteDialog(accordionItem.id)}>
                            </MdDeleteForever>
                            </span>

                        </Tooltip>


                    </div>
                </div>

            </div>
        ) : (
            <Accordion image={accordionItem.icon ? accordionItem.icon : ''} key={accordionItem.id}
                       title={accordionItem.title} accordionOrder={accordionItem.id} hasEditingButton={true}
                       hasGlobalInputFields={childrenHaveNoChildren} categoryId={accordionItem.id}
                       onEdit={() => handleOpenEditDialog(accordionItem)}>

                {accordionItem.childrenPermitTypes && accordionItem.childrenPermitTypes.map((child, index, array) =>
                    renderAccordion(child, index === array.length - 1, false))}
                <Button variant="contained" color="primary" style={{marginTop: '10px'}}
                        onClick={() => handleOpenDialog(accordionItem.id)}>
                    + ნებართვის ფორმის დამატება
                </Button>
            </Accordion>
        );
    };

    return (
        <div>
            {isAdding || isDeleting ? <CustomLoader/> : null}
            {isLoading ? (
                <LoaderCustom/>
            ) : (
                <div className="accordion-grid">
                    {accordionData.map((item, index) => renderAccordion(item, index === accordionData.length - 1))}
                </div>
            )}
            <Dialog style={{ zIndex: 500 }} open={dialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>ნებართვის ფორმის დამატება</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="title"
                        label="სახელი"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formData.title}
                        onChange={handleChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="titleEng"
                        label="სახელი ინგლისურად"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formData.titleEng}
                        onChange={handleChangeEng}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>გაუქმება</Button>
                    <Button
                        onClick={handlePreSubmit}
                        disabled={!formData.title.trim() && !formData.titleEng.trim()} // Button disabled when both fields are empty
                    >
                        დამატება
                    </Button>
                </DialogActions>
            </Dialog>
            <ConfirmationModal isOpen={confirmationModalOpen} onRequestClose={() => setConfirmationModalOpen(false)}
                               onConfirm={handleSubmit}/>
            <ConfirmationModal isOpen={deleteDialogOpen} onRequestClose={handleCloseDeleteDialog}
                               onConfirm={handleDeleteSubmit}
            />
            <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
                <DialogTitle>ნებართვის ფორმის რედაქტირება</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="title"
                        label="სახელი"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={editFormData.title}
                        onChange={handleEditChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="titleEng"
                        label="სახელი ინგლისურად"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={editFormData.titleEng}
                        onChange={handleEditChangeEng}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditDialogOpen(false)}>გაუქმება</Button>
                    <Button onClick={handlePreEditSubmit}>შენახვა</Button>
                </DialogActions>
                <ConfirmationModal
                    isOpen={editConfirmationModalOpen}
                    onRequestClose={() => setEditConfirmationModalOpen(false)}
                    onConfirm={handleActualEditSubmit}
                />
            </Dialog>

        </div>
    );
}

export default AddNewPermitDoc;
